import { Location } from '@angular/common';
import { Component, DestroyRef, OnInit, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Group } from '../../../../../core/shared/models/group.model';
import { GetGroupsByapplication } from '../../../../../core/shared/actions/group.actions';
import { GroupState } from '../../../../../core/shared/states/group.state';
import { GroupModalComponent } from '../../modals/group-modal/group-modal.component';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-group-list',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    LoadingSpinnerComponent,
    MatInputModule,
    MatIcon,
    MatButton,
    MatIconButton,
  ],
})
export class GroupListComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  public dataSource = new MatTableDataSource<Group>();
  public displayedColumns = ['icon', 'group_name', 'Description', 'actions'];
  public loading = true;
  public group!: Group;
  public groupCount = 0;
  public applicationName: any;
  public paginator!: MatPaginator;
  public sort!: MatSort;
  public readonly groups: Observable<Group[]>;

  constructor(
    private store: Store,
    public modalService: NgbModal,
    public location: Location,
    private route: ActivatedRoute
  ) {
    this.applicationName = this.route.snapshot.paramMap.get('Application_Name');
    this.store.dispatch(new GetGroupsByapplication(this.applicationName));
    this.groups = this.store.select(GroupState.getGroupList);
  }

  ngOnInit() {
    this.groups.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.dataSource.data = data;
      this.groupCount = data.length;
      this.loading = false;
    });
  }

  openModal(selectedGroup: Group, formMode: string, applicationName: string, editGroup: boolean) {
    const modalRef = this.modalService.open(GroupModalComponent, { size: 'lg' });
    modalRef.componentInstance.group = selectedGroup;
    modalRef.componentInstance.applicationName = applicationName;
    modalRef.componentInstance.editGroup = editGroup;
    modalRef.componentInstance.formMode = formMode;
  }

  back(): void {
    this.location.back();
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
